export default __webpack_public_path__ + "static/media/CreatorApp.3d8bf258.png";